import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export default function OverallPerformanceChart({ performanceData = [] }) {
    if (!performanceData || performanceData.length === 0) {
        return null;
    }

    const labels = performanceData.map((d, index) => `Test ${index + 1}`);
    const studentScores = performanceData.map((d) => Number(d.studentScore) || 0);
    const top1Scores = performanceData.map((d) => Number(d.top1Score) || 0);

    // Build per-segment colors for the student line
    const segmentColor = (ctx) => {
        const idx = ctx.p1DataIndex;
        if (idx === 0) return "#00E396";
        const prev = studentScores[idx - 1];
        const curr = studentScores[idx];
        if (curr > prev) return "#00E396";   // green  → up
        if (curr < prev) return "#e53935";   // red    → down
        return "#ff9800";                     // orange → same
    };

    const data = {
        labels,
        datasets: [
            {
                label: "Your Performance",
                data: studentScores,
                borderColor: "#00E396",
                backgroundColor: "rgba(0, 227, 150, 0.1)",
                segment: { borderColor: segmentColor },
                pointBackgroundColor: studentScores.map((val, i) => {
                    if (i === 0) return "#00E396";
                    const prev = studentScores[i - 1];
                    if (val > prev) return "#00E396";
                    if (val < prev) return "#e53935";
                    return "#ff9800";
                }),
                pointBorderColor: studentScores.map((val, i) => {
                    if (i === 0) return "#00E396";
                    const prev = studentScores[i - 1];
                    if (val > prev) return "#00E396";
                    if (val < prev) return "#e53935";
                    return "#ff9800";
                }),
                pointBorderWidth: 2,
                pointRadius: 6,
                pointHoverRadius: 8,
                tension: 0.3,
                borderWidth: 3,
                fill: false,
            },
            {
                label: "Top 1% Performance",
                data: top1Scores,
                borderColor: "#1e88e5",
                backgroundColor: "rgba(30, 136, 229, 0.08)",
                borderDash: [6, 4],
                pointBackgroundColor: "#1e88e5",
                pointRadius: 5,
                pointHoverRadius: 7,
                tension: 0.3,
                borderWidth: 2,
                fill: false,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    font: { size: 13, weight: "600" },
                    color: "#333",
                    padding: 20,
                    usePointStyle: true,
                    pointStyleWidth: 16,
                },
            },
            title: {
                display: true,
                text: "Overall Performance Report",
                font: { size: 18, weight: "700" },
                color: "#333",
                padding: { bottom: 20 },
            },
            tooltip: {
                backgroundColor: "rgba(0,0,0,0.8)",
                titleFont: { size: 13 },
                bodyFont: { size: 12 },
                padding: 12,
                cornerRadius: 8,
                callbacks: {
                    label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y} marks`,
                },
            },
        },
        scales: {
            x: {
                offset: true,
                title: {
                    display: true,
                    text: "No. of Tests →",
                    font: { size: 14, weight: "600" },
                    color: "#555",
                },
                grid: { display: false },
                ticks: { font: { size: 12 }, color: "#555" },
            },
            y: {
                title: {
                    display: true,
                    text: "Score (Marks) →",
                    font: { size: 14, weight: "600" },
                    color: "#555",
                },
                grid: { color: "rgba(0,0,0,0.06)" },
                ticks: { font: { size: 12 }, color: "#555" },
            },
        },
    };

    return (
        <div
            className="card shadow-sm border-0 p-4 my-4"
            style={{ borderRadius: "16px", background: "#fff" }}
        >
            <div style={{ position: "relative", height: "350px" }}>
                <Line data={data} options={options} />
            </div>

            {/* Color legend explanation */}
            <div className="d-flex justify-content-center gap-4 mt-3 flex-wrap" style={{ fontSize: "13px" }}>
                <span>
                    <span style={{ display: "inline-block", width: 14, height: 14, borderRadius: "50%", backgroundColor: "#00E396", marginRight: 6, verticalAlign: "middle" }}></span>
                    Score Increased
                </span>
                <span>
                    <span style={{ display: "inline-block", width: 14, height: 14, borderRadius: "50%", backgroundColor: "#e53935", marginRight: 6, verticalAlign: "middle" }}></span>
                    Score Dropped
                </span>
                <span>
                    <span style={{ display: "inline-block", width: 14, height: 14, borderRadius: "50%", backgroundColor: "#ff9800", marginRight: 6, verticalAlign: "middle" }}></span>
                    Same Progress
                </span>
            </div>
        </div>
    );
}
